import React, { memo, useEffect, useState, useRef } from "react";
import { PDFAnnotatorWrapperClient } from "./pdf-annotator-wrapper.client";
import {
  IPdfAnnotations,
  PopoverConfiguration,
} from "~/typings/annotate/annotation";

export const PDFAnnotatorWrapper = memo(function PDFAnnotatorWrapper({
  id,
  popoverConfiguration,
  fileUrl,
  annotations,
}: {
  id: string;
  popoverConfiguration: PopoverConfiguration;
  fileUrl: string;
  annotations: IPdfAnnotations;
}) {
  const [client, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  return client ? (
    <PDFAnnotatorWrapperClient
      id={id}
      popoverConfiguration={popoverConfiguration}
      fileUrl={fileUrl}
      annotations={annotations}
    />
  ) : null;
});
